import { BaseModel } from './baseModel';

export class BaseAuditModel extends BaseModel {
  createdDate: string = '';
  createdBy: string = '';
  lastUpdatedDate: string = '';
  lastUpdatedBy: string = '';
}
